import React from "react";
import { Link, NavLink } from "react-router-dom";
import { EaFullReport } from "./EaFullReport";
import {
  ArrowLeft, Combine, LayoutDashboard, Target, Zap, Flame, BarChart3, Euro, Activity, AlertTriangle, Grid3x3,
  GitCompare, CalendarRange, Gauge, LineChart, ShieldCheck, FileCheck2, Ruler, CalendarDays,
  ChevronsLeft, ChevronsRight, X, Shuffle, Leaf, Sprout,
} from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_monitor-adybo/artifacts/tadicmii_Adybo%20Logo%20Colori%20Bianco%20R.png";

const ICONS = {
  "overview.portfolio": LayoutDashboard, "overview.budget": Target,
  overview: BarChart3, consumption: Activity, costs: Euro, profiles: LineChart, peaks: AlertTriangle,
  heatmap: Grid3x3, compare_points: GitCompare, compare_periods: CalendarRange, power: Gauge,
  pun: LineChart, hedges: ShieldCheck, invoice_check: FileCheck2, efficiency: Ruler, daily: CalendarDays, load_shift: Shuffle,
  "kpi.kpi": Ruler, sustainability: Sprout,
};
const GROUP_ICONS = { overview: Combine, power: Zap, gas: Flame, kpi: Leaf };
const GROUP_COLORS = { overview: "#8F95FF", power: "#B98BFF", gas: "#6F9BFF", kpi: "#34D399" };

function iconFor(key) {
  return ICONS[key] || ICONS[key.split(".")[1]] || BarChart3;
}

function NavItem({ item, search, collapsed }) {
  const Icon = iconFor(item.key);
  const testid = `ea-nav-${item.key.replace(".", "-")}`;
  if (item.status === "disabled") {
    return (
      <div className="sidebar-item opacity-40 cursor-not-allowed" title={item.reason} data-testid={testid}>
        <Icon size={17} className="shrink-0" />
        {!collapsed && <span className="truncate">{item.label}</span>}
      </div>
    );
  }
  return (
    <NavLink to={{ pathname: `/energy-analytics/${item.path}`, search }} end
      className={({ isActive }) => `sidebar-item ${isActive ? "active" : ""} ${collapsed ? "justify-center" : ""}`}
      title={collapsed ? item.label : undefined} data-testid={testid}>
      <Icon size={17} className="shrink-0" />
      {!collapsed && <span className="truncate">{item.label}</span>}
    </NavLink>
  );
}

export function EaSidebar({ groups, search, collapsed, onToggle, onClose }) {
  return (
    <>
      <div className={`h-20 flex items-center border-b border-white/10 ${collapsed ? "justify-center px-2" : "justify-between px-5"}`}>
        {!collapsed && (
          <div className="flex items-center gap-3 min-w-0">
            <img src={LOGO} alt="Adybo" className="h-8" />
            <div className="text-[10px] tracking-[0.2em] text-white/60 font-semibold leading-tight">ENERGY<br />ANALYTICS</div>
          </div>
        )}
        {onClose ? (
          <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-white/10" data-testid="ea-sidebar-close"><X size={18} /></button>
        ) : (
          <button onClick={onToggle} className="p-1.5 rounded-lg hover:bg-white/10 text-white/70" data-testid="ea-sidebar-toggle"
            aria-label={collapsed ? "Espandi menu" : "Comprimi menu"}>
            {collapsed ? <ChevronsRight size={18} /> : <ChevronsLeft size={18} />}
          </button>
        )}
      </div>
      <div className="px-3 pt-4">
        <Link to="/" className={`sidebar-item bg-white/5 ${collapsed ? "justify-center" : ""}`} data-testid="ea-back-to-monitor" title="Torna a Energy Monitor">
          <ArrowLeft size={17} className="shrink-0" />
          {!collapsed && <span>Torna a Energy Monitor</span>}
        </Link>
      </div>
      <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-1" data-testid="ea-sidebar-nav">
        {groups.map((g) => {
          const GIcon = GROUP_ICONS[g.key] || BarChart3;
          return (
            <div key={g.key} className="pb-3" data-testid={`ea-nav-group-${g.key}`}>
              {collapsed ? (
                <div className="flex justify-center py-2"><GIcon size={14} style={{ color: GROUP_COLORS[g.key] }} /></div>
              ) : (
                <div className="text-[10px] uppercase tracking-widest text-white/40 px-3 mb-2 mt-1 flex items-center gap-2">
                  <GIcon size={12} style={{ color: GROUP_COLORS[g.key] }} /> {g.label}
                </div>
              )}
              {g.items.map((it) => <NavItem key={it.key} item={it} search={search} collapsed={collapsed} />)}
            </div>
          );
        })}
      </nav>
      <EaFullReport collapsed={collapsed} />
    </>
  );
}
